import { render } from "./DChartBarSimple.vue?vue&type=template&id=e00c46b6&scoped=true"
import script from "./DChartBarSimple.vue?vue&type=script&lang=js"
export * from "./DChartBarSimple.vue?vue&type=script&lang=js"

import "./DChartBarSimple.vue?vue&type=style&index=0&id=e00c46b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e00c46b6"]])

export default __exports__